import { HTMLAttributes } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Menu, MenuItem, MenuTrigger } from '@backstage/ui';

import { Account, useAccounts } from '../../hooks';
import { specialFormatSelectedAccount } from '../../utils';

const styles = createStyles({
  root: {},
  item: {},
});

type RenderProps = {
  selectedAccount: Account | undefined;
  isLoading: boolean;
  isSwitching: boolean;
};
type Render = (props: RenderProps) => React.ReactNode;

export interface AppAccountSwitcherProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children'>,
    WithStyles<typeof styles> {
  children: Render;
}

const AppAccountSwitcher = (props: AppAccountSwitcherProps) => {
  const { classes, className, children: render, ...rest } = props;
  const { selectedAccount, accounts, switchAccount, isLoading, isSwitching } =
    useAccounts();

  // No accounts to switch between, so don't show anything.
  if (accounts.length < 2) return null;

  return (
    <MenuTrigger>
      {render({ selectedAccount, isLoading, isSwitching })}

      <Menu className={classNames(classes.root, className)} {...rest}>
        {accounts.map(account => (
          <MenuItem
            key={account.accountId}
            id={account.accountId}
            className={classes.item}
            onAction={() => switchAccount(account.accountId)}
          >
            {account.displayName ||
              specialFormatSelectedAccount(account.accountId)}
          </MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  );
};

export default withStyles(styles)(AppAccountSwitcher);
